import { clearAppStorage } from 'src/common/storage';
import { eDiscoveryUrl } from 'src/common/routes';
import { Navigate } from 'react-router-dom';
import useToken from 'src/common/useToken';
import moment from 'moment';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
import { captureLogout } from 'src/common/analytics';

export default function ProtectedRoute(props) {
  const { token } = useToken();

  const Expiretime = Number(localStorage.getItem('Expiretime'));
  const newtime = Date.now();

  const startDate = moment(Expiretime);
  const timeEnd = moment(newtime);
  const diff = timeEnd.diff(startDate);
  const diffDuration = moment.duration(diff);
  // total elapsed minutes — NOT diffDuration.minutes(), which only returns the
  // 0-59 minutes component and so misses idle spans crossing the hour mark.
  const diffMin = diffDuration.asMinutes();

  // Only expire when we actually have a last-activity timestamp; a missing/0
  // Expiretime must not force an immediate logout.
  if (Expiretime && diffMin > 30) {
    captureLogout('session_expired');
    const selectedLanguage = localStorage.getItem('language');
    const languageType = localStorage.getItem('languageType');
    clearAppStorage();
    localStorage.setItem('language', selectedLanguage);
    localStorage.setItem('languageType', languageType);
    setGlobalState('loggedin', false);
    setGlobalState('sessionerror', 'Unauthorized');
    return <Navigate to={eDiscoveryUrl.Login} replace />;
  }

  if (!token) {
    return <Navigate to={eDiscoveryUrl.Login} replace />;
  }

  return props.children;
}

export function SessionMaintained(props) {
  const { token } = useToken();
  const URL = window.location.href;
  // //console.log(URL);
  if (URL.includes('Documentview')) {
    // // //console.log('Shery');
  } else {
    if (token) {
      return <Navigate to={eDiscoveryUrl.CaseS3 + '/1'} replace />;
    }
  }

  return props.children;
}
